import {styled} from '@esgi/ui/theme';
import {Tooltip} from '@esgi/ui/tooltip';
import {Text} from '@esgi/ui/typography';

export const TriggerText = styled(Text, {
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	overflowWrap: 'break-word',
	display: '-webkit-box',
	wordBreak: 'break-all',
	'-webkit-box-orient': 'vertical',
});

export const TooltipContent = styled(Tooltip.Content, {
	width: 250,
});

export const TooltipContentText = styled(Text, {
	wordBreak: 'break-word',
});
